import DataTable from "react-data-table-component";
import Layout from "../../../components/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import MandalAdminLayout from "../../../components/MandalAdminLayout/MandalAdminLayout";

function ManageGroup() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [groupData, setGroupData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [mandals, setMandals] = useState([]);
  const [selectedMandal, setSelectedMandal] = useState("");
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const mandalDetailsId = localStorage.getItem("mandalDetailsId");

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "MandalAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    fetchGroupData();
    fetchMandals();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [search, groupData, selectedMandal]);

  const fetchMandals = async () => {
    try {
      const response = await axios.get(`${apiURL}/MandalDetails/GetPublicList`);
      setMandals(response?.data?.data);
    } catch (error) {
      toast.error(error.response?.data?.data);
    }
  };

  const fetchGroupData = async () => {
    try {
      const response = await axios.get(
        `${apiURL}/SamparkEmploye/Get`,{
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const data = response?.data?.data;

      const filterByMandal = data?.filter(
        (item) => item.mandalDetailsId === Number(mandalDetailsId)
      );
      console.log(`filtedByGroup: ${JSON.stringify(filterByMandal)}`);

      setGroupData(filterByMandal);
      setFilteredData(filterByMandal);
      setLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.data);
      setLoading(false);
    }
  };

  const handleSearch = () => {
    const lowercasedSearch = search.toLowerCase();

    const filtered = groupData.filter((item) => {
      const fullName =
        `${item.firstName} ${item.lastName} ${item.surName}`.toLowerCase();
      const phone = item.phone?.toString().toLowerCase() || "";

      return (
        fullName.includes(lowercasedSearch) || phone.includes(lowercasedSearch)
      );
    });

    setFilteredData(filtered);
  };

  const handleDelete = async (groupId) => {
    const confirmed = window.confirm(
      "Aere you sure want to delete this record?"
    );
    if (!confirmed) return;

    try {
      const response = await axios.delete(
        `${apiURL}/SamparkEmploye/Delete?id=${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success(response?.data?.message);
      fetchGroupData();
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  const columns = [
    {
      name: "No",
      selector: (_, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Name",
      selector: (row) => `${row.firstName} ${row.lastName} ${row.surName}`,
    },
    {
      name: "Mobile Number",
      selector: (row) => row.phone || "-",
    },

    {
      name: "Actions",
      width: "140px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-primary btn-sm mr-1"
            onClick={() =>
              navigate("/update-group2", {
                state: { groupId: row.id },
              })
            }
          >
            <i className="fas fa-pen"></i>
          </button>
          <button
            type="button"
            className="btn btn-danger btn-sm mr-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
      center: "true",
    },
  ];

  return (
    <MandalAdminLayout ac2="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h5>Group Details</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/mandal-admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Group List</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    <div className="bd-highlight">
                      <input
                        className="form-control mb-3"
                        type="search"
                        placeholder="Search"
                        title="Search within table"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div className="bd-highlight"></div>
                    <div className="bd-highlight">
                      <Link to="/add-group2">
                        <button
                          type="button"
                          className="btn btn-primary px-md-4 py-md-2 px-2 py-2"
                        >
                          <i className="fas fa-plus"></i> Add
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body text-center">
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm "
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      responsive
                      className="custom-table"
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setCurrentPage(1);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </MandalAdminLayout>
  );
}

export default ManageGroup;
